import { Link } from "gatsby"
import React from "react"
import WhyWork1 from "../../images/why-work-1.png"
import WhyWork2 from "../../images/why-work-2.png"
import WhyWork3 from "../../images/why-work-3.png"
import WhyWork4 from "../../images/why-work-4.png"

const WhyWork = () => {
  return (
    <section className="bg-neutral py-12">
      <div className="mx-auto container px-6 w-full lg:w-11/12 xl:w-3/5">
        <h2 className="text-5xl text-center leading-tight pb-8">
          <span className="text-secondary font-semibold block">Why</span> work
          with us?
        </h2>
        <div className="grid grid-cols-1 grid-rows-1 lg:grid-cols-2 md:grid-rows-2 justify-items-center gap-y-8 gap-x-16 text-center text-xl">
          <div>
            <div className="mx-auto">
              <img
                src={WhyWork1}
                alt="Multiple technologies"
                className="mx-auto pb-8"
              />
            </div>
            <div className="flex flex-col">
              <h3 className="text-4xl pb-8 md:flex-grow">
                <span className="font-bold text-secondary block">Multiple</span>{" "}
                technologies
              </h3>
              <p className="pb-8">
                We work with the <b>latest digital tools</b> and technologies
              </p>
            </div>
          </div>

          <div>
            <div className="mx-auto">
              <img
                src={WhyWork2}
                alt="Deliver high-impact processes"
                className="mx-auto pb-8"
              />
            </div>
            <div className="flex flex-col">
              <h3 className="text-4xl pb-8 md:flex-grow">
                <span className="font-bold text-secondary block">
                  We deliver
                </span>{" "}
                high-impact processes
              </h3>
              <p className="pb-8">
                We <b>optimize processes</b> with the most advanced technologies
              </p>
            </div>
          </div>

          <div>
            <div className="mx-auto">
              <img
                src={WhyWork3}
                alt="High recruitment standards"
                className="mx-auto pb-8"
              />
            </div>
            <div className="flex flex-col">
              <h3 className="text-4xl pb-8 md:flex-grow">
                <span className="font-bold text-secondary block">
                  High recruitment
                </span>{" "}
                standards
              </h3>
              <p className="pb-8">
                We check the background history according to{" "}
                <b>client’s specifications</b>
              </p>
            </div>
          </div>

          <div>
            <div className="mx-auto">
              <img
                src={WhyWork4}
                alt="Efficient transitions"
                className="mx-auto pb-8"
              />
            </div>
            <div className="flex flex-col">
              <h3 className="text-4xl pb-8 md:flex-grow">
                <span className="font-bold text-secondary block">
                  Efficient
                </span>{" "}
                transitions
              </h3>
              <p className="pb-8">
                We prepare our talents for <b>efficient onboarding</b>
              </p>
            </div>
          </div>
        </div>
        <Link
          to="/services"
          title="Our Services"
          className="table mx-auto my-8 hover:text-white hover:bg-secondary hover:text-variant btn"
        >
          Our Services
        </Link>
      </div>
    </section>
  )
}

export default WhyWork
